import { css } from 'lit';

const styles = css`
  :host {
    display: contents;
  }
`;

export default styles;
